import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from 'src/app/reusables/i18n/translate';

import { DataFiles, DEFAULT_COUNTRY_CODE, DEFAULT_LANG, JSONDataService, Lang, Translation } from '../data';
import { BrandState, CountryState } from '../app-state';


/** Translate service initializer (APP_INITIALIZER). */
export function provideTranslateServiceInitializer(): () => Promise<boolean> {
    return async () => {
        const translateService: TranslateService<Translation> = inject(TranslateService<Translation>);
        const jsonDataService: JSONDataService = inject(JSONDataService);
        const countryState: CountryState = inject(CountryState);
        const brandState: BrandState = inject(BrandState);

        await countryState.init();
        const langs: Promise<Lang[]> = firstValueFrom(jsonDataService.getDataCollection<Lang>(DataFiles.LANGS));
        const defaultLang: Promise<string> = langs.then(
            (langs: Lang[]) => {
                const defaultLang: string = (countryState.country?.code_lang ?? DEFAULT_LANG).toLowerCase();
                if (langs.find((lang: Lang) => lang.code === defaultLang)) {
                    return defaultLang;
                }
                return DEFAULT_LANG;
            }
        );
        return translateService.init({
            defaultLang,
            translationsListInitializerFn: () => jsonDataService.getDataCollection<Translation>(DataFiles.TRANSLATIONS),
            translationListFilterByLangFn: (lg: string, translation: Translation) => (!translation.code_lang ||  translation.code_lang.toLowerCase() === lg),
            translationListFilterByCodeFn: (code: string, translation: Translation) => (
                translation.code === code
                && (
                    !translation.code_marque
                    || !brandState.brandCode
                    || translation.code_marque.toLowerCase() === brandState.brandCode?.toLowerCase()
                )
            ),
            translationListFilterByCountryByLangFn: (countryCode: string, lg: string, translation: Translation) => (
                (!translation.code_pays || translation.code_pays.toLowerCase() === countryCode.toLowerCase())
                && (!translation.code_lang || translation.code_lang.toLowerCase() === lg)
            ),
            getTranslationValueFn: (translation: Translation) => translation.content,
            sorterFn: (a: Translation, b: Translation) => {

                function __nullBrandSorter(): number {
                    if (!a.code_marque && b.code_marque) {
                        return -1;
                    }
                    return 1;
                }

                function __nullLangSorter(): number {
                    if (!a.code_lang && b.code_lang) {
                        return -1;
                    }
                    return 1;
                }

                if (a.code_lang && b.code_lang) {
                    return __nullBrandSorter();
                }
                
                return __nullLangSorter();
            }
        });
    }
}
